
<template>
  <div>
    <div v-if="debug_show_page_name == true" style="color: green">
      page_0090_notice
    </div>
    <app-header>esma</app-header>
    <div :class="'container ' + pageContainerSize">
      <title-and-search :title="pageTitle"></title-and-search>


      <tabs nav-style="tabs" @active="onTabChanged($event)" :value="selectedTab">
        <tab header="お知らせ" ></tab>
        <tab header="お知らせ 履歴一覧" ></tab>
      </tabs>

      <search-control
        style="padding-bottom: 10px"
        :field_names="allFields"
        @change="searchControlChangedDatasource"
      ></search-control>
      <ag-grid-vue
        style="width: 100%; height: 325px"
        class="ag-blue"
        :gridOptions="gridOptions"
      ></ag-grid-vue>
      <div style="margin-top: 5px">
        <br />
        <button
          v-show="this.selectedTab == 0"
          :disabled="checkUserPermission(true,permissionMode.ADD) == false"
          class="btn btn-primary"
          style="
            min-width: 100px;
            float: right;
            margin-left: 10px;
            background: #92D050;
            border-color: #92D050;
          "
          @click="addNew"
        >
          新規
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import { AgGridVue } from "ag-grid-vue";
import { fields, filed_types } from "@/rules/fields_notice";
import _ from "lodash";
import uuid from "uuid";
import { utils } from "@/libs/utils";
import acl from "@/rules/acl_rules";
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";
import _debug from 'debug';
var mdebug = _debug("esma:notice");

import { bus } from "@/libs/bus";
import { tab, tabs } from "vue-strap/dist/vue-strap.js";
export default {
  mixins: [mixinPageCommon, mixinDatasource],
  components: {
    'ag-grid-vue': AgGridVue,
    tab, tabs
  },
  data() {
    return {
      api_name: "notice",
      page_acl: acl.master,
      detail_page: "page_0090_notice_detail",
      execute_filter_on_back: true,
      link_to_open: "#",
      selected_tab:0
    };
  },
  computed: {
    pageTitle(){
      if(this.selectedTab == 1){
        return "お知らせ 履歴一覧";
      }else{
        return "お知らせ";
      }
    },
    selectedTab:{
      get(){
        return this.selected_tab;
      },
      set(v){
        this.selected_tab = v;
      }
    },
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields(){
      return this.tabFieldList;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      if(this.selectedTab == 1){
        return [
          utils.extend(fields.history_date, {}),
          utils.extend(fields.from_user, {}),
          
          utils.extend(fields.to_user, {}),
          utils.extend(fields.message, {}),
          utils.extend(fields.importance, {})
        ];
      }else{
        return [
          utils.extend(fields.create_date, {}),
          utils.extend(fields.from_user, {}),
          // utils.extend(fields.to_company, {tab_size:20}),
          // utils.extend(fields.to_department, {tab_size:20}),
          // utils.extend(fields.to_team, {tab_size:20}),
          utils.extend(fields.to_user, {}),
          utils.extend(fields.message, {}),
          utils.extend(fields.importance, {})
        ];
      }
    },
  },
  methods: {
    onTabChanged(index) {
      // Set the selectedTab with the selected tab.
      this.selectedTab = index;
      this.clearSearchFields();

      // Recreate the columns. Based on tabFieldList
      this.gridOptions.api.setColumnDefs((()=>{
        return this.createColumnDefs();
      })());

      // Set if will load the data by history or not.
      this.api_request_options = {get_history:this.selectedTab};

      // Reload the counter;
      this.countRows("onTabChanged");

      // Reload the data
      this.gridOptions.api.purgeInfiniteCache();
      // Resize the columnts
      this.gridOptions.api.sizeColumnsToFit();

      // Change the URL.
      if(index == 1){
        return this.$router.push({ name: this.detail_page.replace("_detail","_history"), params: { } });
      }else {
        return this.$router.push({ name: this.detail_page.replace("_detail",""), params: { } });
      }
    },
    onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: this.detail_page, params: {  seq_id:data.seq_id} });
    },
    addNew() {
      return this.$router.push({
        name: this.detail_page,
        params: { seq_id: "new" },
      });
    },
    onDelete() {
      if (this.selected_row > -1) {
        return this.$router.push({
          name: this.detail_page,
          params: { seq_id: this.selected_row, cmd: "delete" },
        });
      }
    },
    onEdit() {
      return this.$router.push({
        name: this.detail_page,
        params: { seq_id: this.selected_row, cmd: "edit" },
      });
    },
    createColumnDefs() {
      return this.commonCreateColumnDefs({
        show_details: true,
        show_checkbox: false,
      });
    },
    onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    },
  },
  mounted() {
    console.log("Mounted")
    if(this.$route.meta.tab_index == 1){
      this.selectedTab = 1;
    }else{
      this.selectedTab = 0;
    }
    this.api_request_options = {get_history:this.selectedTab};
    this.gridOptions.api.purgeInfiniteCache();
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy() {},
  beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.api_request_options = {get_history:this.selectedTab};
    this.initDatasource();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// page_0090_notice.vue?34320d89